/**
 * Created by bootdo.
 * 角色相关api
 */
import * as API from '.'
import $const from '../common/constant'

export default {

  //保存附件
  save: (params,config,action) => {
	  if(!action){
		  action=$const.apiServer.Base+'/sysAtt/save';
	  }
    return API.POST(action, params,config)
  },
  //根据id删除单个附件
  delAttById: (params) => {
    return API.GET($const.apiServer.Base+'/sysAtt/delAttById', params)
  },
  //根据id数组查询多个附件
  getAttByIds: (params) => {
    return API.GET($const.apiServer.Base+'/sysAtt/getAttByIds', params)
  },
  //根据id数组删除多个附件
  delAttByIds: (params) => {
    return API.GET($const.apiServer.Base+'/sysAtt/delAttByIds', params)
  }
  
}



// WEBPACK FOOTER //
// ./src/api/api_att.js